export default "__VITE_ASSET__B9ql0u4m__ 1200w";